import FormViewItem from '../FormViewItem.vue';
import FormFieldShell from '../FormFieldShell.vue';
import FormViewPreviewDrawer from '../FormViewPreviewDrawer.vue';
import FormViewFileList from '../FormViewFileList.vue';

export const EMPTY_VIEW_TEXT = '—';

export function formatViewText(value, fallback = EMPTY_VIEW_TEXT) {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  if (Array.isArray(value) && value.length === 0) {
    return fallback;
  }
  return value;
}

export function isEmptyViewValue(value) {
  return formatViewText(value, '') === '';
}

export default {
  components: {
    FormViewItem,
    FormFieldShell,
    FormViewPreviewDrawer,
    FormViewFileList,
  },
  props: {
    as_view: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewPreviewVisible: false,
      viewPreviewUrl: '',
    };
  },
  methods: {
    formatViewText,
    isEmptyViewValue,
    openViewPreview(url) {
      if (!url) {
        return;
      }
      this.viewPreviewUrl = url;
      this.viewPreviewVisible = true;
    },
    toViewLinkHref(value) {
      if (!value) {
        return '';
      }
      const text = String(value).trim();
      if (/^https?:\/\//i.test(text)) {
        return text;
      }
      return `http://${text}`;
    },
  },
};
